import { WithApplicationFromRoute } from '@features/applications/components/with-application-from-route.tsx';
import WizardSteps from '@features/wizard/components/wizard-steps.tsx';

const IdentityPage = WithApplicationFromRoute(WizardSteps);

export default IdentityPage;
